var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBack33(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "21px",
    viewBox: "0 0 13 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBack33") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guest",
    transform: "translate(-15.000000, -37.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arrow-(4)",
    transform: "translate(15.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36847815,10.504439 L12.646665,2.64804878 C12.8746056,2.4322439 13,2.14370732 13,1.83604878 C13,1.52821951 12.8746056,1.23985366 12.646665,1.02370732 L11.9212847,0.335658537 C11.6937038,0.119170732 11.389483,0 11.0652927,0 C10.7411024,0 10.4372415,0.119170732 10.2094807,0.335658537 L0.352980056,9.68936585 C0.124319748,9.90619512 -0.000894709229,10.1959268 0,10.5039268 C-0.000894709229,10.8132927 0.124139842,11.1026829 0.352980056,11.3196829 L10.2003055,20.6643415 C10.4280663,20.8808293 10.7319272,21 11.0562974,21 C11.3804877,21 11.6843487,20.8808293 11.9122894,20.6643415 L12.6374898,19.9762927 C13.1093827,19.5284634 13.1093827,18.799439 12.6374898,18.3517805 L4.36847815,10.504439 Z",
    id: "icBack33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack33);
export default __webpack_public_path__ + "static/media/icBack33.0980d2e20409e3e3ef887fd9a0c3085e.svg";
export { ForwardRef as ReactComponent };